export default "__VITE_ASSET__BPS2fhXr__"